// Module
var code = "<div class=\"h-100 w-100 p-4 scroll-y\" id=\"container\"> </div>";
// Exports
export default code;